import { render } from "./RequestPatientForm.vue?vue&type=template&id=238bd7d7&scoped=true"
import script from "./RequestPatientForm.vue?vue&type=script&lang=js"
export * from "./RequestPatientForm.vue?vue&type=script&lang=js"

import "./RequestPatientForm.vue?vue&type=style&index=0&id=238bd7d7&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238bd7d7"]])

export default __exports__